import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { GridControlled } from '@customer/components/tables/grid/GridControlled';
import AnalyticsTable from '@customer/components/tables/analytics-table/AnalyticsTable';
import Metric from '@customer/components/data-display/metric/Metric';
import useAnalyticsSubPage from '@customer/templates/health-sub-page/useAnalyticsSubPage';
import { AssetBasicModel, AssetListScenarios } from '@customer/store/apis/assetsApi';
import { AssetSidePanelTab } from '@customer/store/slices/globalSlice';
import {
  columnDefAssetDeviceName,
  columnDefAssetNameMismatch,
  columnDefDeviceId,
  columnDefDeviceType,
} from '@customer/components/tables/grid/columnDefs';
import { ColDef } from 'ag-grid-community';
import FilterButton from '@customer/components/inputs/filter-button/FilterButton';
import SubTabsPageContent from '@customer/templates/sub-tabs-page/SubTabsPageContent';
import FilterSummary from '@customer/components/inputs/filter-summary/FilterSummary';

const AssetGridSliceKey = 'AssetsHealthConfigAssetNameMismatch';

export function AssetNameMismatch() {
  const { t } = useTranslation();

  const [columnDefs] = useState<ColDef<AssetBasicModel>[]>([
    { ...columnDefAssetNameMismatch(t) },
    { ...columnDefAssetDeviceName(t) },
    { ...columnDefDeviceType(t) },
    { ...columnDefDeviceId(t) },
  ]);

  const {
    assets,
    hasData,
    noDataDescription,
    countAll,
    countFilter,
    countScenarioFilter,
    onRowClick,
  } = useAnalyticsSubPage({
    scenario: AssetListScenarios.HealthNameMismatch,
    sidePanelTab: AssetSidePanelTab.Configuration,
  });

  return (
    <SubTabsPageContent
      headerSummary={
        <FilterSummary
          transKey="ShowingAssets"
          filteredTransKey="ShowingFilteredAssets"
          countAll={countAll}
          countFilter={countFilter}
        />
      }
      headerActions={<FilterButton disabled />}
      body={
        <AnalyticsTable
          title={t('AssetNameMismatch')}
          metrics={
            <Metric dataPrimary={countScenarioFilter} dataSecondary={countFilter} isFraction />
          }
          hasData={hasData}
          noDataDescription={noDataDescription}
          maxVisibleRows={20}
        >
          <GridControlled<AssetBasicModel>
            sliceKey={AssetGridSliceKey}
            rowData={assets}
            columnDefs={columnDefs}
            noRowsMessage={t('No assets')}
            onRowClick={onRowClick}
          />
        </AnalyticsTable>
      }
    />
  );
}

export default AssetNameMismatch;
